import config from '~/config';
import { CountryCodeValue } from '~/types/localization/localizationHelperTypes';

export default (countryCode: CountryCodeValue): boolean => {
  return config.quickAddToCartRestrictedCountries.includes(countryCode);
};
